<template>
    <div class="container-fluid">
        <ToastTemplet :bus="toast"></ToastTemplet>
        <div class="row mt-5">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Products</h3>

                <div class="card-tools">
                    <input class="btn search_box" type="text" placeholder="Search" @keyup="searchit" v-model="search" aria-label="Search">
                    <button class="btn btn-success" @click="newProduct()">Add New </button>

                    <vue-excel-xlsx
                        :data="product_mastersExcel"
                        :columns="columns"
                        :filename="'ProductData'"
                        :sheetname="'sheetname'"
                        class="btn btn-success"
                        >
                        Excel
                    </vue-excel-xlsx>

                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                        <tr>
                            <th>NO</th>
                            <th>Product Name</th>
                            <th>Bank Name</th>
                            <th>Modify</th>
                        </tr>
                        <tr v-for="(product_master,i) in product_masters.data" :key="product_master.PRODUCT_ID">
                            <td>{{ i+1 }}</td>
                            <td>{{ product_master.Product_Name }}</td>
                            <td> {{ product_master.Bank_Name}} </td>
                            <td>
                                <a href="#" @click="editProduct(product_master)"><i class="fas fa-edit"></i></a>/
                                <a href="#" @click="deleteProduct(product_master.PRODUCT_ID)"><i class="fas fa-trash-alt red"></i></a>
                            </td>
                        </tr>
                        </table>
                    </div>
                    <!-- /.card-body -->
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-md-9">
                                    <pagination :data="product_masters" @pagination-change-page="loadAndSearchProduct" :limit="this.$PaginationCounterLimit">
                                    <span slot="prev-nav">&lt; Previous</span>
                                    <span slot="next-nav">Next &gt;</span>
                                </pagination>
                            </div>
                            <div class="col-md-1 show-text">
                                Show
                            </div>
                            <div class="col-md-1 pagination">
                                <multiselect
                                    v-model="$PaginationLimit"
                                    :options="this.$PaginationOptions"
                                    :allow-empty="false"
                                    open-direction="top"
                                    :show-labels="false"
                                    @input="loadAndSearchProduct(1)"
                                    aria-required="true">
                                </multiselect>
                            </div>
                            <div class="col-md-1 entries-text">
                                Entries
                            </div>
                        </div>
                    </div>
                    </div>
                    <!-- /.card -->
                </div>
                </div><!-- /.row -->
                <!-- Modal -->
            <div class="modal fade" id="product_model" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode" id="exampleModalLabel">Add New Product</h5>
                    <h5 class="modal-title" v-show="editmode" id="exampleModalLabel">Update Product</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="editmode ? UpdateProduct() : CreateProduct()" @keydown="form.onKeydown($event)">
                <div class="modal-body">
                        <div class="form-group">
                            <label>PRODUCT Name</label>
                            <input v-model="form.Product_Name" type="text" name="Product_Name"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('Product_Name') }">
                            <has-error :form="form" field="Product_Name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Bank Name</label>
                            <multiselect
                                    v-model="form.BANK_ID_REF"
                                    :options="bank_master"
                                    :allow-empty="false"
                                    open-direction="bottom"
                                    deselect-label="Can't remove this value"
                                    label="Bank_Name"
                                    track-by="BANK_ID"
                                    aria-required="true">
                            </multiselect>
                            <has-error :form="form" field="Bank_Name"></has-error>
                        </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" v-show="!editmode" class="btn btn-primary">Save Product</button>
                    <button type="submit" v-show="editmode" class="btn btn-success">Update</button>
                </div>
                </form>
                </div>
            </div>
            </div>
            <!--end Model-->
    </div>
</template>

<script>
    import ToastTemplet from "../widget/toast";
    export default {
        components: { Multiselect,ToastTemplet },
        data(){
            return{
                toast: new Vue(),
                editmode:false,
                search:'',
                bank_master:[],
                product_masters:{},
                product_mastersExcel:[],
                form: new Form({
                    PRODUCT_ID:'',
                    BANK_ID:'',
                    BANK_ID_REF:'',
                    Bank_Name:'',
                    Product_Name:''
                }),
                columns : [
                    {
                        label: "Bank Name",
                        field: "Bank_Name",
                    },
                    {
                        label: "Product Name",
                        field: "Product_Name",
                    },
                    {
                        label: "Product Is Active",
                        field: "Product_Is_Active",
                    },
                ],
            }
        },
        created() {
            Fire.$on('searching',()=>{
                this.loadAndSearchProduct();
            })
            Fire.$on('AfterChangeProduct',()=>{
                this.loadAndSearchProduct();
            });
        },
        mounted(){
            this.loadBank();
            this.loadAndSearchProduct();
        },
        methods:{
            searchit: _.debounce(()=>{
                Fire.$emit('searching');
            },500),
            UpdateProduct(){
                this.toast.$emit("LoadingOn");
                this.form.put('product_master/'+this.form.PRODUCT_ID)

                .then(()=> {
                    Fire.$emit('AfterChangeProduct');
                    $('#product_model').modal('hide');
                    this.toast.$emit('LoadingOffSuccess', "Product Updated successfully");
                })
                .catch(()=> {
                    this.toast.$emit('LoadingOffError', "your request could not be processed.");
                })
            },
            editProduct(product_master){
                this.editmode = true,
                this.form.reset();
                $('#product_model').modal('show');
                this.form.fill(product_master);
                this.form.BANK_ID_REF = {"BANK_ID":this.form.BANK_ID_REF,"Bank_Name":this.form.Bank_Name};
            },
            newProduct(){
                this.editmode = false,
                this.form.reset();
                $('#product_model').modal('show');
            },
            deleteProduct(PRODUCT_ID){
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                    }).then((result) => {
                        if(result.value){
                            this.form.delete('product_master/'+PRODUCT_ID).then(()=>{
                                Fire.$emit('AfterChangeProduct');
                                this.toast.$emit('SwalSuccess',"Deleted!", "Product Deleted.");

                            }).catch(()=>{
                                this.toast.$emit('SwalWarning',"Failed!", "There was something wrong, Or Product Is Already In Use");
                            })
                        }
                    })
            },
            CreateProduct(){
                this.toast.$emit("LoadingOn");
                this.form.post('product_master')
                .then(()=>{
                    $('#product_model').modal('hide')
                    // this.loadAndSearchProduct();
                    Fire.$emit('AfterChangeProduct');
                    this.toast.$emit('LoadingOffSuccess', "Product Create successfully");

                })
                .catch(()=>{
                    this.toast.$emit('LoadingOffError', "your Request Failed.");
                })
            },
            loadBank(){
                axios.get('/loadBank')
                .then(({data})=> {this.bank_master = data})
                .catch(() => {
                    this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                });
            },
            loadAndSearchProduct(page = 1) {
                this.toast.$emit('ProgressBarLoading');
                axios
                    .get("loadAndSearchProduct?query=" + this.search +"&page=" + page + "&PaginationLimit="+ this.$PaginationLimit)
                    .then(({ data }) => {
                        this.product_masters = data,
                        this.toast.$emit('ProgressBarFinish'),
                        this.loadAndSearchProductExcel()
                    })
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any Such User");
                    });
            },
            loadAndSearchProductExcel(page = 1) {
                this.toast.$emit('ProgressBarLoading');
                axios
                    .get("loadAndSearchProductExcel?query=" + this.search +"&page=" + page + "&PaginationLimit="+ this.$PaginationLimit)
                    .then(({ data }) => {
                        this.product_mastersExcel = data,
                        this.toast.$emit('ProgressBarFinish')
                    })
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any Such User");
                    });
            },
        }
    }
</script>
